(function () {
  const ATC_SELECTOR = 'button.ProductForm__AddToCart, button[data-action="add-to-cart"], [data-testid="standalone-add-to-cart"], .add-to-cart-button, add-to-cart-component button, button[name="add"]';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-custom-pack-builder]').forEach(function (el) {
      // Idempotency guard — never init the same element twice
      if (el.dataset.cpbInitialized === '1') return;
      el.dataset.cpbInitialized = '1';
      initBuilder(el);
    });
  });

  function initBuilder(root) {
    const grid = root.querySelector('[data-cpb-grid]');
    const countEl = root.querySelector('[data-cpb-count]');
    const pricePerItemEl = root.querySelector('[data-cpb-price-per-item]');

    const itemLabel = root.dataset.itemLabel || 't-shirt';
    let quantity = 10;
    let activeSlotIndex = null;
    let selections = {};
    let currentSelectedSize = '';
    let currentCategoryHandle = '';
    let currentProducts = [];
    let isCustomPackActive = false;

    // ==========================================
    // MOVE DRAWER + OVERLAY TO <body>
    // ==========================================
    const drawerEl  = document.getElementById('bundle-drawer');
    const overlayEl = document.getElementById('bundle-drawer-overlay');
    const closeBtn  = document.getElementById('close-bundle-drawer');

    if (drawerEl && drawerEl.parentElement !== document.body) {
      document.body.appendChild(drawerEl);
    }
    if (overlayEl && overlayEl.parentElement !== document.body) {
      document.body.appendChild(overlayEl);
    }

    // ==========================================
    // FULL IMAGE VIEWER POPUP (all images of a drawer product)
    // ==========================================
    const imageViewerOverlay = document.getElementById('cpb-image-viewer-overlay');
    const imageViewerEl      = document.getElementById('cpb-image-viewer');
    const imageViewerTitle   = document.getElementById('cpb-image-viewer-title');
    const imageViewerGrid    = document.getElementById('cpb-image-viewer-grid');
    const imageViewerClose   = document.getElementById('cpb-image-viewer-close');

    // Appended to <body> after the drawer, so it stacks on top even though
    // both share the same max z-index (equal z-index paints in DOM order).
    if (imageViewerOverlay && imageViewerOverlay.parentElement !== document.body) {
      document.body.appendChild(imageViewerOverlay);
    }
    if (imageViewerEl && imageViewerEl.parentElement !== document.body) {
      document.body.appendChild(imageViewerEl);
    }

    function openImageViewer(title, images) {
      if (!imageViewerEl || !images || !images.length) return;
      if (imageViewerTitle) imageViewerTitle.textContent = title || '';
      if (imageViewerGrid) {
        imageViewerGrid.innerHTML = images
          .map(src => `<img src="${src}" alt="${title || ''}">`)
          .join('');
      }
      imageViewerEl.classList.add('active');
      imageViewerOverlay?.classList.add('active');
    }
    function closeImageViewer() {
      imageViewerEl?.classList.remove('active');
      imageViewerOverlay?.classList.remove('active');
    }
    imageViewerClose?.addEventListener('click', closeImageViewer);
    imageViewerOverlay?.addEventListener('click', closeImageViewer);

    function openBundleDrawer() {
      drawerEl?.classList.add('active');
      overlayEl?.classList.add('active');
      syncDrawerSizeWithProductPage();
    }

    // Carries whatever size is already selected up top (or the auto-synced
    // default) into the drawer's own size buttons, so the shopper doesn't
    // have to pick a size again inside the drawer.
    function syncDrawerSizeWithProductPage() {
      const pageSize = (window.currentProductData && window.currentProductData.size) || currentSelectedSize;
      if (!pageSize) return;

      currentSelectedSize = pageSize;
      const drawerSizeButtons = drawerEl?.querySelectorAll('.drawer-size-btn');
      drawerSizeButtons?.forEach(function (b) {
        b.classList.toggle('active', b.dataset.size === pageSize);
      });
      const drawerSizeText = document.getElementById('drawer-selected-size-text');
      if (drawerSizeText) drawerSizeText.textContent = pageSize;

      if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
    }
    function closeBundleDrawer() {
      drawerEl?.classList.remove('active');
      overlayEl?.classList.remove('active');
    }
    closeBtn?.addEventListener('click', closeBundleDrawer);
    overlayEl?.addEventListener('click', closeBundleDrawer);

    // ==========================================
    // ATC BUTTON HELPERS (span-aware)
    // ==========================================
    function getPriceSpan(btn) {
      if (!btn || !btn.querySelectorAll) return null;
      const spans = btn.querySelectorAll('span');
      for (const s of spans) {
        if (s.classList.contains('Button__SeparatorDot')) continue;
        // Never treat our own injected bundle-total span as "the theme's price span" —
        // otherwise updateCount() would hide the very total it just wrote.
        if (s.classList.contains('cpb-injected-price') || s.classList.contains('cpb-price-wrapper')) continue;
        if (/[£$€¥₹]\s*[\d]/.test(s.textContent)) return s;
      }
      return null;
    }
    function getLabelSpan(btn) {
      if (!btn || !btn.querySelectorAll) return null;
      const spans = btn.querySelectorAll('span');
      for (const s of spans) {
        if (s.classList.contains('Button__SeparatorDot')) continue;
        if (/[£$€¥₹]\s*[\d]/.test(s.textContent)) continue;
        return s;
      }
      return null;
    }
    function getSeparatorSpan(btn) {
      return btn?.querySelector?.('span.Button__SeparatorDot:not(.cpb-injected-sep)') || null;
    }
    // This theme already shows "ADD TO BAG" permanently via its own bold
    // `.atc-main-text` span. The OTHER plain-text span(s) inside the button
    // (the old "Add to bag" label the bundle code used to write into) are
    // just duplicates once the bundle total is showing — this finds those
    // so they can be hidden instead of written into.
    function getExtraLabelSpans(btn) {
      if (!btn || !btn.querySelectorAll) return [];
      return Array.from(btn.querySelectorAll('span')).filter(s =>
        !s.classList.contains('atc-main-text') &&
        !s.classList.contains('atc-top-row') &&
        !s.classList.contains('Button__SeparatorDot') &&
        !s.classList.contains('cpb-injected-sep') &&
        !s.classList.contains('cpb-injected-price') &&
        !s.classList.contains('cpb-price-wrapper') &&
        !/[£$€¥₹]\s*[\d]/.test(s.textContent)
      );
    }
    // The theme's own ATC-button script (in main-product.liquid) builds a
    // ".atc-top-row" wrapper holding the "ADD TO BAG" text so it can sit
    // beside a price instead of on its own line. We build the bundle's
    // price wrapper *inside* that same row so both stay lined up in one
    // row; if that row isn't there yet for some reason, we create it
    // ourselves so the layout still works.
    function ensurePriceSpan(btn) {
      let topRow = btn.querySelector(':scope > .atc-top-row');
      if (!topRow) {
        topRow = document.createElement('span');
        topRow.className = 'atc-top-row';
        btn.insertBefore(topRow, btn.firstChild);
      }

      let wrapper = topRow.querySelector('.cpb-price-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.className = 'cpb-price-wrapper';
        // No inline `display` here on purpose — the CSS controls visibility
        // (hidden by default, shown via the --visible class below) so there's
        // no specificity fight between an inline style and a stylesheet
        // !important rule.
        wrapper.style.cssText = 'align-items: center; gap: 4px;';

        const sep = document.createElement('span');
        sep.className = 'Button__SeparatorDot cpb-injected-sep';
        sep.style.cssText = 'display: inline-flex;';
        sep.textContent = '·';
        wrapper.appendChild(sep);

        const price = document.createElement('span');
        price.className = 'cpb-injected-price';
        price.style.cssText = 'display: inline-flex;';
        wrapper.appendChild(price);

        topRow.appendChild(wrapper);
      }
      return wrapper.querySelector('.cpb-injected-price');
    }
    function getCurrencySymbol(btn) {
      // Primary: derived from Liquid's own `money` filter output — always
      // rendered regardless of the ATC button's "show price in button" setting
      if (window.cpbFormattedPrice) {
        const fromPage = window.cpbFormattedPrice.match(/([£$€¥₹])/);
        if (fromPage) return fromPage[1];
      }
      // Fallback: scan the ATC button, in case cpbFormattedPrice isn't available
      const priceSpan = getPriceSpan(btn);
      if (!priceSpan) return '$';
      const m = priceSpan.textContent.match(/([£$€¥₹])/);
      return m ? m[1] : '$';
    }
    function cacheOriginalButtonText(btn) {
      if (btn.dataset.cpbCached === '1') return;
      const priceSpan = getPriceSpan(btn);
      const labelSpan = getLabelSpan(btn);
      if (priceSpan) btn.dataset.cpbOriginalPrice = priceSpan.textContent;
      if (labelSpan) btn.dataset.cpbOriginalLabel = labelSpan.textContent;
      btn.dataset.cpbCached = '1';
    }

    // ==========================================
    // SHOW / HIDE
    // ==========================================
    function showSlots() {
      root.removeAttribute('hidden');
      root.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
      isCustomPackActive = true;
      document.body.classList.add('custom-pack-active');
      updateCount();
    }

    // function hideSlots() {
    //   root.setAttribute('hidden', 'hidden');
    //   root.style.cssText = 'display: none !important;';
    //   isCustomPackActive = false;
    //   document.body.classList.remove('custom-pack-active');
    //   document.body.classList.remove('bundle-is-complete');
    //   restoreATCButton();
    // }

    function restoreATCButton() {
      document.querySelectorAll(ATC_SELECTOR).forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.style.removeProperty('opacity');
        btn.style.removeProperty('pointer-events');
        btn.style.removeProperty('cursor');
        btn.style.removeProperty('filter');

        const priceSpan = getPriceSpan(btn);
        const labelSpan = getLabelSpan(btn);
        const sepSpan   = getSeparatorSpan(btn);

        if (priceSpan && btn.dataset.cpbOriginalPrice) {
          priceSpan.textContent = btn.dataset.cpbOriginalPrice;
          priceSpan.style.display = '';
        }
        if (labelSpan && btn.dataset.cpbOriginalLabel) {
          labelSpan.textContent = btn.dataset.cpbOriginalLabel;
        }
        if (sepSpan) sepSpan.style.display = '';
      });
    }

    function isCustomPackSwatch(el) {
      return !!(el && el.dataset && el.dataset.swatchType === 'custom_pack');
    }

    // Matches Shopify's own rounding for the real per-item discount that
    // gets applied in the cart: the discount amount is floored to the
    // nearest cent (not rounded), THEN subtracted — e.g. £27.99 at 24% off
    // is floor(27.99 * 0.24 * 100) = 671 cents off, giving £21.28, not the
    // £21.27 you'd get from a plain 27.99 * 0.76 multiplication. Rounding
    // each item this way (instead of only rounding the final summed total)
    // is what makes the sum of these prices match the cart drawer subtotal
    // exactly, cent for cent.
    function calcDiscountedPrice(originalPrice, discountPercent) {
      const originalCents = Math.round(Number(originalPrice) * 100);
      const discountCents = Math.floor(originalCents * (Number(discountPercent) || 0) / 100);
      return (originalCents - discountCents) / 100;
    }

    // ==========================================
    // AUTO SELECT DEFAULT PRODUCT
    // ==========================================
    function autoSelectFirstProduct() {
      if (window.currentProductData && window.currentProductData.id) {
        const currentProd = window.currentProductData;
        const basePrice = parseFloat(currentProd.price || 0);
        const discountPercent = getActivePackDiscountPercent();
        const discountedPrice = calcDiscountedPrice(basePrice, discountPercent);
        selections[0] = {
          id: currentProd.id,
          title: currentProd.title,
          image: currentProd.image,
          size: currentProd.size || currentSelectedSize || '',
          price: discountedPrice,
          // The real per-unit price Shopify will actually charge at checkout
          // (no discount is applied on the cart itself) — used for the ATC
          // button total so it always matches the cart drawer subtotal.
          originalPrice: basePrice
        };
      }
    }

    function setQuantity(newQuantity) {
      if (!newQuantity || isNaN(newQuantity)) return;
      newQuantity = parseInt(newQuantity, 10);

      if (quantity !== newQuantity) {
        selections = {};
        autoSelectFirstProduct();
      }
      quantity = newQuantity;
      renderSlots();
      updatePricePerItem();
      // Pack changed — re-render drawer product prices with the new discount %
      if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
    }

    // Currently active pack's discount % (editable by the client in the theme
    // editor) — shared by the "price per t-shirt" line and the drawer product prices.
    function getActivePackDiscountPercent() {
      const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
      return activePackBtn
        ? (parseFloat(activePackBtn.getAttribute('data-discount-percent')) || 0)
        : 0;
    }

    // ==========================================
    // PRICE PER T-SHIRT (pack-tier based)
    // ==========================================
    // Reads the currently active pack's discount % + quantity (both
    // editable by the client in the theme editor) so it always reflects
    // whatever discounts are set — no code change needed if the client
    // updates a pack's discount later.
    //
    // The bundle can mix products from different collections that have
    // different original prices. Each filled slot already stores its own
    // correctly-discounted price (computed from THAT product's own price —
    // see addProductToActiveSlot / autoSelectFirstProduct), so once the
    // customer has picked real products we average those actual prices
    // instead of always assuming the current page product's price. Before
    // anything is picked, we still show a starting estimate based on the
    // current page's product so the line isn't blank.
    function updatePricePerItem() {
      if (!pricePerItemEl) return;
      if (!quantity) {
        pricePerItemEl.hidden = true;
        return;
      }

      const discountPercent = getActivePackDiscountPercent();
      const filledKeys = Object.keys(selections).filter(key => selections[key] && !isNaN(Number(selections[key].price)));

      let perItem;
      if (filledKeys.length) {
        const total = filledKeys.reduce((sum, key) => sum + Number(selections[key].price), 0);
        perItem = total / filledKeys.length;
      } else {
        const basePrice = (window.currentProductData && window.currentProductData.price)
          ? Number(window.currentProductData.price)
          : 0;
        if (!basePrice) {
          pricePerItemEl.hidden = true;
          return;
        }
        perItem = calcDiscountedPrice(basePrice, discountPercent);
      }

      const atcButtons = document.querySelectorAll(ATC_SELECTOR);
      const currency = getCurrencySymbol(atcButtons[0]);

      pricePerItemEl.textContent = currency + perItem.toFixed(2) + ' /' + itemLabel;
      pricePerItemEl.hidden = false;
    }

    // ==========================================
    // RENDER SLOTS
    // ==========================================
    function renderSlots() {
      if (!grid) return;
      grid.innerHTML = '';

      for (let i = 0; i < quantity; i++) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'cpb-slot';
        slot.dataset.index = i;

        const selected = selections[i];
        if (selected) {
          slot.classList.add('cpb-slot--filled');

          const removeBtn = document.createElement('span');
          removeBtn.className = 'remove-item';
          removeBtn.innerHTML = '&times;';
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            delete selections[i];
            renderSlots();
            updatePricePerItem();
          });
          slot.appendChild(removeBtn);

          const img = document.createElement('img');
          img.src = selected.image;
          img.alt = selected.title;
          slot.appendChild(img);

          const info = document.createElement('div');
          info.className = 'cpb-slot__info';
          if (selected.size) {
            const sizeEl = document.createElement('span');
            sizeEl.className = 'cpb-slot__size';
            sizeEl.textContent = selected.size;
            info.appendChild(sizeEl);
          }
          slot.appendChild(info);
        } else {
          const plus = document.createElement('span');
          plus.className = 'cpb-slot__plus';
          plus.textContent = '+';
          slot.appendChild(plus);
        }

        slot.addEventListener('click', function () {
          activeSlotIndex = i;
          openBundleDrawer();
        });

        grid.appendChild(slot);
      }
      updateCount();
    }

    // ==========================================
    // COUNT + PRICE + ATC STATE
    // ==========================================
    function updateCount() {
      if (!countEl) return;
      const filled = Object.keys(selections).length;
      countEl.textContent = filled + ' / ' + quantity;

      if (!isCustomPackActive) return;

      // Total that Shopify will actually charge at checkout. The cart
      // already applies the real per-item bundle discount (that's the
      // "Pack of 3: -£X.XX" tag + reduced price shown on each cart drawer
      // line), so the price that actually matches the cart drawer subtotal
      // is each item's DISCOUNTED price (sel.price) — not its original
      // price. (A previous version of this summed originalPrice instead,
      // on the wrong assumption that the cart charges full price — that's
      // what caused the ATC total and cart subtotal to disagree.)
      let totalPrice = 0;
      Object.keys(selections).forEach(key => {
        const sel = selections[key];
        if (!sel) return;
        const amount = Number(sel.price);
        if (!isNaN(amount)) totalPrice += amount;
      });
const atcButtons = document.querySelectorAll(ATC_SELECTOR);
const isFull = (filled === quantity);

atcButtons.forEach(btn => {
  cacheOriginalButtonText(btn);

  // "ADD TO BAG" is already shown permanently via the theme's own bold
  // .atc-main-text span — any other plain-text span is a leftover
  // duplicate, so hide it instead of writing into it.
  getExtraLabelSpans(btn).forEach(s => { s.style.display = 'none'; });

  // Hide the theme's own price span + separator (only present when its
  // "show price in button" setting is ON) — we render our own single-row
  // wrapper below so there's never a duplicate/stacked price.
  const themePriceSpan = getPriceSpan(btn);
  const themeSepSpan = getSeparatorSpan(btn);
  if (themePriceSpan) themePriceSpan.style.display = 'none';
  if (themeSepSpan) themeSepSpan.style.display = 'none';

  const currency = getCurrencySymbol(btn);

  if (isFull && totalPrice > 0) {
    const priceSpan = ensurePriceSpan(btn);
    priceSpan.textContent = currency + totalPrice.toFixed(2);
    // Toggle a class rather than inline style — the CSS hides
    // .cpb-price-wrapper by default with a plain `display: none` and only
    // shows it via `.cpb-price-wrapper--visible` with !important, so the
    // price only ever appears once the bundle is genuinely complete.
    const wrapper = btn.querySelector('.cpb-price-wrapper');
    if (wrapper) wrapper.classList.add('cpb-price-wrapper--visible');
  } else {
    const wrapper = btn.querySelector('.cpb-price-wrapper');
    if (wrapper) wrapper.classList.remove('cpb-price-wrapper--visible');
  }
});
      // let discountRate = 0;
      // if (quantity === 3) discountRate = 0.33;
      // else if (quantity === 6) discountRate = 0.40;
      // else if (quantity >= 10) discountRate = 0.50;

      // const discountedPrice = totalPrice * (1 - discountRate);
      // const atcButtons = document.querySelectorAll(ATC_SELECTOR);
      // const isFull = (filled === quantity);

      // atcButtons.forEach(btn => {
      //   cacheOriginalButtonText(btn);
      //   const labelSpan = getLabelSpan(btn);
      //   const priceSpan = getPriceSpan(btn);
      //   const sepSpan   = getSeparatorSpan(btn);
      //   const currency  = getCurrencySymbol(btn);

      //   if (isFull && discountedPrice > 0) {
      //     if (labelSpan) labelSpan.textContent = 'ADD TO BAG';
      //     if (priceSpan) {
      //       priceSpan.textContent = currency + discountedPrice.toFixed(2);
      //       priceSpan.style.display = '';
      //     }
      //     if (sepSpan) sepSpan.style.display = '';
      //   } else {
      //     if (labelSpan) labelSpan.textContent = 'ADD TO BAG';
      //     if (priceSpan) priceSpan.style.display = 'none';
      //     if (sepSpan) sepSpan.style.display = 'none';
      //   }
      // });

      toggleAddToCartButton(isFull);
    }

    function toggleAddToCartButton(isFull) {
      const atcButtons = document.querySelectorAll(ATC_SELECTOR);

      if (isFull) {
        document.body.classList.add('bundle-is-complete');
        atcButtons.forEach(btn => {
          btn.removeAttribute('disabled');
          btn.disabled = false;
          btn.style.setProperty('opacity', '1', 'important');
          btn.style.setProperty('pointer-events', 'auto', 'important');
          btn.style.setProperty('cursor', 'pointer', 'important');
          btn.style.removeProperty('filter');
        });
      } else {
        document.body.classList.remove('bundle-is-complete');
        atcButtons.forEach(btn => {
          btn.setAttribute('disabled', 'true');
          btn.disabled = true;
          btn.style.setProperty('opacity', '0.4', 'important');
          btn.style.setProperty('pointer-events', 'none', 'important');
          btn.style.setProperty('cursor', 'not-allowed', 'important');
          btn.style.setProperty('filter', 'grayscale(1)', 'important');
        });
      }
    }

    // ==========================================
    // DRAWER: SIZE + CATEGORY + PRODUCTS
    // ==========================================
    const drawerSizeButtons   = drawerEl?.querySelectorAll('.drawer-size-btn');
    const drawerCategoryCards = drawerEl?.querySelectorAll('.drawer-cat-card');
    const drawerSizeText      = document.getElementById('drawer-selected-size-text');
    const drawerCatText       = document.getElementById('drawer-selected-cat-text');
    const drawerProductsBox   = document.getElementById('drawer-products-container');

    drawerSizeButtons?.forEach(btn => {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('sold-out')) return;
        drawerSizeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        currentSelectedSize = btn.dataset.size;
        if (drawerSizeText) drawerSizeText.textContent = currentSelectedSize;
        if (currentCategoryHandle) renderDrawerProducts();
      });
    });

    drawerCategoryCards?.forEach(card => {
      card.addEventListener('click', function () {
        drawerCategoryCards.forEach(c => c.classList.remove('active'));
        card.classList.add('active');
        currentCategoryHandle = card.dataset.handle;
        if (drawerCatText) drawerCatText.textContent = card.dataset.title;
        fetchCollectionProducts(currentCategoryHandle);
      });
    });

    // Default-select the first category so the drawer isn't left on
    // "Select Category" — matches the first card rendered from drawer_collections
    if (drawerCategoryCards && drawerCategoryCards.length > 0) {
      const firstCategoryCard = drawerCategoryCards[0];
      firstCategoryCard.classList.add('active');
      currentCategoryHandle = firstCategoryCard.dataset.handle;
      if (drawerCatText) drawerCatText.textContent = firstCategoryCard.dataset.title;
      fetchCollectionProducts(currentCategoryHandle);
    }

    function fetchCollectionProducts(handle) {
      if (!drawerProductsBox) return;
      drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Loading products...</p>';
      fetch(`/collections/${handle}/products.json?limit=250`)
        .then(res => res.json())
        .then(data => {
          currentProducts = data.products || [];
          renderDrawerProducts();
        })
        .catch(() => {
          drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Error loading products.</p>';
        });
    }

    function renderDrawerProducts() {
      if (!drawerProductsBox) return;
      if (!currentSelectedSize) {
        drawerProductsBox.innerHTML = '<p class="drawer-loading-text">Please select a size to view products.</p>';
        return;
      }
      if (!currentProducts.length) {
        drawerProductsBox.innerHTML = '<p class="drawer-loading-text">No products in this category.</p>';
        return;
      }

      const cards = [];
      currentProducts.forEach(product => {
        const matchingVariant = product.variants.find(v =>
          v.option1 === currentSelectedSize ||
          v.option2 === currentSelectedSize ||
          v.option3 === currentSelectedSize
        );
        // Show every product for the category regardless of stock in the selected
        // size — fall back to the first variant just to have a price/image if this
        // exact size doesn't exist on the product at all. The ADD button below
        // is what actually gets disabled when it's not purchasable.
        const variant = matchingVariant || product.variants[0];
        if (!variant) return;
        const inStockForSize = !!(matchingVariant && matchingVariant.available);

        // All images for this product, for the slider — fall back to the variant/featured image if the product has none
        let images = (product.images || []).map(img => img.src).filter(Boolean);
        if (!images.length) {
          const fallbackImg = variant.featured_image?.src || '';
          if (fallbackImg) images = [fallbackImg];
        }
        // Original price is the product's own price; the shown discount comes from
        // the currently selected pack (10/6/3/singles), not the product's own compare_at_price
        const originalPrice = parseFloat(variant.price);
        cards.push({ product, variant, images, originalPrice, inStockForSize });
      });

      if (!cards.length) {
        drawerProductsBox.innerHTML = `<p class="drawer-loading-text">No products in this category.</p>`;
        return;
      }

      // Dynamic currency symbol — matches whatever currency the store/product ATC button shows, instead of a hardcoded $
      const currency = getCurrencySymbol(document.querySelector(ATC_SELECTOR));
      const discountPercent = getActivePackDiscountPercent();

      drawerProductsBox.innerHTML = '';
      cards.forEach(({ product, variant, images, originalPrice, inStockForSize }) => {
        const card = document.createElement('div');
        card.className = 'drawer-product-card' + (inStockForSize ? '' : ' drawer-product-card--oos');

        const discountedPrice = calcDiscountedPrice(originalPrice, discountPercent);
        const priceHtml = discountPercent > 0
          ? `<span class="drawer-price-compare">${currency}${originalPrice.toFixed(2)}</span> / <span class="drawer-price-final">${currency}${discountedPrice.toFixed(2)}</span>`
          : `<span class="drawer-price-final">${currency}${originalPrice.toFixed(2)}</span>`;

        const sliderImagesHtml = images.map((src, i) =>
          `<img src="${src}" alt="${product.title}" class="drawer-slider-img"${i === 0 ? '' : ' hidden'} data-index="${i}">`
        ).join('');

        const arrowsHtml = images.length > 1
          ? `<button type="button" class="drawer-slider-arrow drawer-slider-prev" aria-label="Previous image">&#8249;</button>
             <button type="button" class="drawer-slider-arrow drawer-slider-next" aria-label="Next image">&#8250;</button>`
          : '';

        const oosNoteHtml = inStockForSize
          ? ''
          : `<div class="drawer-product-oos-note">Out of stock in ${currentSelectedSize}</div>`;

        card.innerHTML = `
          <div class="drawer-product-media">
            ${sliderImagesHtml}
            ${arrowsHtml}
          </div>
          <div class="drawer-product-title">${product.title}</div>
          <div class="drawer-product-price">${priceHtml}</div>
          ${oosNoteHtml}
          <button class="drawer-add-btn"${inStockForSize ? '' : ' disabled'} type="button">${inStockForSize ? 'ADD' : 'OUT OF STOCK'}</button>
        `;

        // Slider arrow behaviour — one image visible at a time, wraps around both ends
        if (images.length > 1) {
          let activeIndex = 0;
          const slideImgs = card.querySelectorAll('.drawer-slider-img');
          const showSlide = (newIndex) => {
            slideImgs[activeIndex].hidden = true;
            activeIndex = (newIndex + slideImgs.length) % slideImgs.length;
            slideImgs[activeIndex].hidden = false;
          };
          card.querySelector('.drawer-slider-prev').addEventListener('click', function (e) {
            e.stopPropagation();
            showSlide(activeIndex - 1);
          });
          card.querySelector('.drawer-slider-next').addEventListener('click', function (e) {
            e.stopPropagation();
            showSlide(activeIndex + 1);
          });
        }

        // Clicking the image (not the arrows, which stop propagation) opens the full-image popup
        card.querySelector('.drawer-product-media').addEventListener('click', function () {
          openImageViewer(product.title, images);
        });

        if (inStockForSize) {
          card.querySelector('.drawer-add-btn').addEventListener('click', function () {
            addProductToActiveSlot({
              id: variant.id,
              title: product.title,
              image: images[0] || '',
              size: currentSelectedSize,
              price: discountedPrice,
              // Real per-unit price Shopify charges for THIS product/variant —
              // used for the ATC button total so it matches the cart drawer.
              originalPrice: originalPrice
            });
          });
        }
        drawerProductsBox.appendChild(card);
      });
    }

    function addProductToActiveSlot(prod) {
      if (activeSlotIndex === null || activeSlotIndex === undefined) {
        for (let i = 0; i < quantity; i++) {
          if (!selections[i]) { activeSlotIndex = i; break; }
        }
      }
      if (activeSlotIndex === null || activeSlotIndex === undefined) return;
      selections[activeSlotIndex] = prod;
      renderSlots();
      updatePricePerItem();
      activeSlotIndex = null;
      closeBundleDrawer();
    }

    // ==========================================
    // NUCLEAR ATC INTERCEPT (window-level capture)
    // Runs before ANY app or theme listener can intercept.
    // Triple hook: click + mousedown + submit.
    // ==========================================
    window.addEventListener('click', function (e) {
      const atcBtn = e.target.closest?.(ATC_SELECTOR);
      if (!atcBtn) return;
      if (!isCustomPackActive) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const filled = Object.keys(selections).length;
      if (filled < quantity) {
        grid?.classList.remove('cpb-shake');
        void grid?.offsetWidth;
        grid?.classList.add('cpb-shake');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      addBundleToCart(atcBtn);
      return false;
    }, true);

    window.addEventListener('mousedown', function (e) {
      const atcBtn = e.target.closest?.(ATC_SELECTOR);
      if (!atcBtn) return;
      if (!isCustomPackActive) return;
      const filled = Object.keys(selections).length;
      if (filled < quantity) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    window.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!isCustomPackActive) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const filled = Object.keys(selections).length;
      if (filled === quantity) {
        const atcBtn = form.querySelector(ATC_SELECTOR);
        addBundleToCart(atcBtn || form);
      }
      return false;
    }, true);

    function addBundleToCart(atcBtn) {
      const bundleId = 'bundle-' + Date.now();
      const items = [];
      for (let i = 0; i < quantity; i++) {
        const sel = selections[i];
        if (!sel || !sel.id) continue;
        items.push({
          id: sel.id,
          quantity: 1,
          properties: {
            'Bundle Size': sel.size || '',
            '_bundle_id': bundleId
          }
        });
      }
      if (!items.length) {
        console.warn('CPB: No items to add — selections empty', selections);
        return;
      }

      console.log('CPB: Adding bundle', items);

      const labelSpan = getLabelSpan(atcBtn);
      const originalLabel = labelSpan?.textContent || '';
      if (labelSpan) labelSpan.textContent = 'ADDING...';
      if (atcBtn && atcBtn.disabled !== undefined) atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(data => {
          console.log('CPB: Cart add response', data);
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Add to cart failed');
          }
          // Dispatch theme's own event — this triggers _onProductAdded which
// re-renders the cart AND opens the drawer automatically.
document.dispatchEvent(new CustomEvent('product:added', {
  bubbles: true,
  detail: {
    variant: data.items ? data.items[0] : null,
    quantity: items.length
  }
}));

// Also dispatch generic events for other apps/listeners
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: data }));

// Reset button state
if (labelSpan) labelSpan.textContent = originalLabel;
if (atcBtn && atcBtn.disabled !== undefined) atcBtn.disabled = false;
        })
        .catch(err => {
          console.error('CPB: Bundle add error:', err);
          if (labelSpan) labelSpan.textContent = 'TRY AGAIN';
          setTimeout(() => {
            if (labelSpan) labelSpan.textContent = originalLabel;
            if (atcBtn && atcBtn.disabled !== undefined) atcBtn.disabled = false;
          }, 1500);
        });
    }

    // ==========================================
    // SWATCH + PACK CLICK LISTENERS
    // ==========================================
    document.addEventListener('click', function (e) {
      const swatchBtn = e.target.closest('[data-color-pack-option]');
      if (swatchBtn) {
        if (isCustomPackSwatch(swatchBtn)) {
          showSlots();
          const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
          let q = activePackBtn ? (activePackBtn.getAttribute('data-quantity') || activePackBtn.dataset.packKey) : '10';
          const match = String(q).match(/\d+/);
          setQuantity(match ? match[0] : 10);
        }
      }

      const packBtn = e.target.closest('[data-pack-option]');
      if (packBtn) {
        document.querySelectorAll('[data-pack-option]').forEach(function (b) {
          b.classList.remove('pack-option--active');
        });
        packBtn.classList.add('pack-option--active');

        let q = packBtn.getAttribute('data-quantity') || packBtn.dataset.packKey;
        const match = String(q).match(/\d+/);
        if (match) setQuantity(match[0]);
      }
    });

    // ==========================================
    // SYNC WITH MAIN PRODUCT SIZE SELECTOR
    // ==========================================
    // Keeps window.currentProductData and the auto-filled first slot in sync
    // whenever the shopper picks a different size/option up top — so it
    // doesn't stay stuck on whatever was selected when the page first loaded.
    function applyVariantChange(newVariant) {
      if (!newVariant) return;

      const previousId = window.currentProductData ? window.currentProductData.id : null;
      if (previousId === newVariant.id) return; // no real change

      window.currentProductData = {
        id: newVariant.id,
        title: (window.currentProductData && window.currentProductData.title) || '',
        image: newVariant.featured_image ? newVariant.featured_image.src : ((window.currentProductData && window.currentProductData.image) || ''),
        price: Number(newVariant.price) / 100,
        size: newVariant.option1 || newVariant.option2 || newVariant.option3 || ''
      };

      // Only touch slot 1 if it still holds the auto-filled default product —
      // if the shopper already swapped it out via the drawer, leave it alone
      if (selections[0] && selections[0].id === previousId) {
        autoSelectFirstProduct(); // re-applies pack discount to the new price too
        renderSlots();
      }

      updatePricePerItem();
      if (currentCategoryHandle && currentProducts.length) renderDrawerProducts();
    }

    // Path 1: some themes dispatch this custom event on variant change — use it if present
    document.addEventListener('variant:changed', function (e) {
      if (!isCustomPackActive) return;
      applyVariantChange(e.detail && e.detail.variant);
    });

    // Path 2 (primary/reliable): resolve the variant ourselves from the size/option
    // radios inside #variant_selection, using the full variant list rendered into
    // window.cpbProductVariants. Doesn't depend on any theme JS event firing.
    function getVariantFromSelectors() {
      if (!window.cpbProductVariants || !window.cpbProductVariants.length) return null;
      const variantSelectionEl = document.getElementById('variant_selection');
      if (!variantSelectionEl) return null;

      const selectedByPosition = {};
      variantSelectionEl.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        const pos = parseInt(radio.getAttribute('data-option-position'), 10);
        if (!isNaN(pos)) selectedByPosition[pos] = radio.value;
      });
      if (!Object.keys(selectedByPosition).length) return null;

      return window.cpbProductVariants.find(function (v) {
        if (selectedByPosition[1] !== undefined && v.option1 !== selectedByPosition[1]) return false;
        if (selectedByPosition[2] !== undefined && v.option2 !== selectedByPosition[2]) return false;
        if (selectedByPosition[3] !== undefined && v.option3 !== selectedByPosition[3]) return false;
        return true;
      }) || null;
    }

    document.addEventListener('change', function (e) {
      if (!isCustomPackActive) return;
      if (!e.target.closest || !e.target.closest('#variant_selection')) return;
      applyVariantChange(getVariantFromSelectors());
    });

    // The theme also has popover/button-based size options (data-action="select-value")
    // that don't fire a native "change" event — catch those too.
    document.addEventListener('click', function (e) {
      if (!isCustomPackActive) return;
      if (e.target.closest && e.target.closest('#variant_selection [data-action="select-value"]')) {
        // Let the theme's own click handler update the radio/selected state first
        setTimeout(function () {
          applyVariantChange(getVariantFromSelectors());
        }, 0);
      }
    });

    // ==========================================
    // INITIAL STATE
    // ==========================================
    autoSelectFirstProduct();
    renderSlots();

    const activeSwatch = document.querySelector('[data-color-pack-option].color-pack-option--active');
    if (isCustomPackSwatch(activeSwatch)) {
      document.body.classList.add('custom-pack-active');
      isCustomPackActive = true;
      const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
      let q = activePackBtn ? (activePackBtn.getAttribute('data-quantity') || activePackBtn.dataset.packKey) : '10';
      const match = String(q).match(/\d+/);
      setQuantity(match ? match[0] : 10);
      updateCount();
    }

    // Show the pack-tier price-per-t-shirt regardless of custom-pack-active
    // state, since it reflects the pack selector (10/6/3/singles), not just
    // the custom-pack drawer flow.
    updatePricePerItem();
  }
})();